import { 
  EpDevPApiClient 
} from '../EpDevPApiClient';
import {
  IEpDevPAbout,
  IEpDevPSupportApiClient,
  IEpDevPSystemTicket,
  IEpDevPSystemTicketCreate,
  IEpDevPUserTicketCreate,
  IEpDevPUserTicketResponse,
} from '../types';
import { 
  EpDevPSupportApiPathsFactory 
} from './EpDevPSupportApiFactories';



export class EpDevPSupportApiClient extends EpDevPApiClient implements IEpDevPSupportApiClient {

  public async createSystemTicket({ requestBody }:{
    requestBody: IEpDevPSystemTicketCreate;
  }): Promise<IEpDevPSystemTicket> {
    const epDevPSystemTicket: IEpDevPSystemTicket = await this.request({
      url: await this.createUrl(EpDevPSupportApiPathsFactory.createSystemTicketPath()),
      method: 'POST',
      body: JSON.stringify(requestBody)
    });
    return epDevPSystemTicket;
  }

  public async createUserTicket({ requestBody }: {
    requestBody: IEpDevPUserTicketCreate;
  }): Promise<IEpDevPUserTicketResponse> {
    const epDevPUserTicketResponse: IEpDevPUserTicketResponse = await this.request({
      url: await this.createUrl(EpDevPSupportApiPathsFactory.createUserTicketPath()),
      method: 'POST',
      body: JSON.stringify(requestBody)
    });
    return epDevPUserTicketResponse;
  }

  public async about(): Promise<IEpDevPAbout> {
    const epDevPAbout: IEpDevPAbout = await this.request({
      url: await this.createUrl(EpDevPSupportApiPathsFactory.createAboutPath()),
      method: 'GET'
    });
    return epDevPAbout;
  }


}
